import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import AffiliateForm from './AffiliateForm';

import AffiliatesApi from 'Api/CRM/Modules/AffiliatesApi';
import Affiliate from 'Api/Models/Affiliate';
import Card from 'crm/elements/common/Card';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';
import useNumberParams from 'crm/hooks/useNumberParams';
import useOnce from 'crm/hooks/useOnce';

function AffiliateEdit() {
    const { id } = useNumberParams();
    const [affiliate, setAffiliate] = useState<Affiliate>();
    const [errors, setErrors] = useState<ValidationErrors>({});
    const history = useHistory();

    useOnce(() => AffiliatesApi.getModelById(Affiliate, id).then(setAffiliate));

    const handleEditAffiliate = async (newAffiliate: Affiliate) => {
        try {
            setAffiliate(await AffiliatesApi.updateModel(newAffiliate));
            history.push('/affiliates');
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    return (
        <Card title="Update Affiliate">
            <AffiliateForm action={handleEditAffiliate} errors={errors} affiliateData={affiliate} />
        </Card>
    );
}

export default AffiliateEdit;
